export const MCP_DOCS_URL = "https://docs.topicflow.com/mcp-server";

/** The address an AI tool connects to: this server, so staging and local stay off production. */
export const getMcpServerUrl = (origin: string) => `${origin}/mcp`;
